import { I18nString } from '@models/i18n/i18n-string';
import { map } from 'jquery';
import { CommonModel } from '../common-model';
import { I18nStringMap } from '../i18n/i18n-string-map';



export type TargetType = 'COMPANY' | 'INDIVIDUAL' | 'AGENT';

export class Company extends CommonModel{
    companyId: string;
    companyNameEn: string;
    companyNameCn: string;
    businessNameEn: string;
    businessNameCn: string;
    registeredOfficeAddress1:string;
    registeredOfficeAddress2:string;
    registeredOfficeAddress3:string;
    allLocrSameAsRoa:boolean;
    taxIdentificationNumTin: string;
    taxRepresentative: string;
    notSolungClient:boolean;
    placeOfBusinessInHKDate:Date;
    registrationInHKDate:Date;
    companyTypeOverseas: string;
    companyNo: string;
    companyNoRegisteredInHk: string;
    businessRegistrationNumber: string;
    isBrExpired:boolean;
    deadlineForRenewalOfBr: Date;
    deadlineForRenewalOfGovLicence: Date;
    sameDeadlineAsEsNotification: Date;
    deadlineForAnnualReturn: Date;
    periodicalFinancialYearStart: Date;
    periodicalFinancialYearEnd: Date;

    // dateForAnnualReturn: Date;
    dateOfObtainingIroExemptionStatus: Date;
    objectsOfTheCompany: string;
    typeOfIroExemption: string;
    slaReferenceNo: string;
    emailAddress: string;
    phoneNo: string;
    faxNo: string;
    incorporationDate: Date;
    startingUpTheCompany: string;
    otherBusinessActivities: string;
    businessActivitiesOnBrCert: string;
    isBusinessCommenced: boolean;
    commencementOfBusiness: Date;
    locationOfBusinessActivities: string;
    auditorEngagedCan: string;
    auditorEngagedDoa: Date;
    auditorEngagedLfrp: Date;
    maxNumberOfRegisteredMember: number;
    registeredMemberEffectiveDate: Date;
    remarks: string;
    billingFromDate: Date;
    billingToDate: Date;
    issuedShareCapital: number;
    amlCheckDate:Date;
    conflictCheckDate:Date;
    additionalKycInformation:string;
    adverseFacts:string;
    lastUpdateWorkflowId: string;



    _showName:string;
    _tabKey:string;

    constructor() {
        super();
        this.companyId = null;
        this.allLocrSameAsRoa =false;
        this.notSolungClient =false;
        this.isBrExpired =false;
        this._tabKey = '';
    }

    static search(term: string, item: Company) {
        term = term.toLocaleLowerCase();
        return item.companyNameEn == term;
    }
}


export class  BaseSearchingCriteria{
    code: string;
    name: string;
    createdDate: string;
}


export class  CompanySearchingCriteria extends BaseSearchingCriteria{
    stakeholderSearch: string;
    agentSearch: string;
}
 
